/*
 * @Author: xiaolong.xu
 * @Date: 2023-08-10 10:15:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-03-21 11:14:18
 * @Description: 会员标识
 */
import React, { useCallback, useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import dayjs from 'dayjs'
import { Button } from 'antd'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { useTranslation, dynamicTrans } from '@/libs/next-lang'
import { useModalWrap } from '@/components'
import gioTrackEvent from '@/utils/gio'
import eventMap from '@/utils/gio/eventMap'
import globalStore from '@/globalStore'
import IconSvg from '@/components/IconSvg'
import { useRouter } from 'next/router'
import { getTaskClaimReward } from '@/services/common'
import eventBus from '@/utils/eventBus'
import { COOKIES_MAP } from '@/constants'
import useFbe from '@/hooks/useFbe'
import { getMemberTria, getMemberTriaPackageInfo } from './services'
import { EVENT_NAME } from './constants'

import styles from './index.module.less'

interface Props {
  grade?: 0 | 1 // 会员等级, 免费、高级
  manyTimes?: 1 // 第几次领取，目前14天会员可以领取两次，领取条件和交互有区别
  taskCode?: null // 任务编号
  disabled: boolean
  validityPeriod?: number // 会员有效期
  classNames?: string
  subTitle?: React.ReactElement | string | null
  layout?: 'default' | 'long' // 默认和长款
  onClick?: () => void
  onSucess: () => void
}

const useSucessResultModal = () => {
  const router: any = useRouter()
  const [, setInitData] = useState<any>({})
  const [dateString, setDateString] = useState<any>('') // 会员领取日期

  const { t } = useTranslation(['components'])

  const { showModal, hideModal, render, visible } = useModalWrap({
    modalProps: {
      title: null,
      width: 525,
      bodyStyle: { padding: 0 },
      footer: null,
      afterClose: () => {
        setInitData({})
      },
      // closable:false,
      onCancel: () => {
        hideModal()
      },
    },
    children: () => {
      return (
        <div className={styles['content-wrapper']}>
          <div className="success-result" style={{ textAlign: 'center', marginTop: 57 }}>
            <div style={{ marginBottom: 25 }}>
              <IconSvg type="icon-chenggong2" />
              <span className="ml-5" style={{ fontSize: 18 }}>
                {dynamicTrans(t('components:t96'), { dateString })}
              </span>
            </div>
            {/* {initData?.manyTimes === 1 && (
              <div className="ml-5" style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)' }}>
                14天会员生效期内
              </div>
            )}
            <div>
              <Steps current={initData?.manyTimes === 1 ? 0 : 1} progressDot>
                <Step
                  title={<span style={{ fontSize: 16, color: '#FFFFFF' }}>新用户注册</span>}
                  description={
                    <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)' }}>14天会员</span>
                  }
                />
                <Step
                  title={<span style={{ fontSize: 16, color: '#FFFFFF' }}>完成20个模板作品</span>}
                  description={
                    <span style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)' }}>
                      可升级至28天会员
                    </span>
                  }
                />
              </Steps>
            </div> */}
          </div>
          <Button
            block
            className="confirm-btn"
            onClick={() => {
              hideModal()
              router.push('/inspiration/template')
            }}
          >
            {t('components:t87')}
          </Button>
        </div>
      )
    },
  })

  // 监听第一次领取， 领取以后刷新任务
  useEffect(() => {
    const fn = () => {
      const userInfo = JSON.parse(localStorage.getItem('user') || '{}')
      const end = dayjs(dayjs(userInfo.expireTime).format('YYYY-MM-DD'))
      const start = dayjs(dayjs(dayjs().valueOf()).format('YYYY-MM-DD'))
      const day = end.diff(start, 'days')
      setDateString(day || '')
    }
    // 正常情况弹框
    visible && fn()
  }, [visible])

  const show = useCallback(
    initData => {
      setInitData(initData)
      showModal()
    },
    [showModal],
  )

  return {
    showModal: show,
    hideModal,
    render,
  }
}

const ProbationaryMemberArea = observer((props: Props) => {
  const router: any = useRouter()
  const { onSucess, onClick, manyTimes = 1, taskCode = 'works20', disabled = false } = props
  const { isFbe } = useFbe()
  const [memberTriaInfo, setMemberTriaInfo] = useState<any>({})

  const { t } = useTranslation(['components'])

  // 试用会员领取
  const onDefaultClick = useCallback(async () => {
    if (disabled) {
      return
    }

    try {
      // 第一次领取
      if (manyTimes === 1) {
        gioTrackEvent(eventMap.VIP_for_free_click)
        const { data } = await getMemberTria()
        if (data?.code === 0) {
          // 更新会员信息
          globalStore.updateUserInfo(data?.result || {})
          onSucess()
          eventBus.emit(EVENT_NAME.FIRST_CLAIM)
        }
      } else if (manyTimes === 2) {
        gioTrackEvent(eventMap.VIP_task_rewards_for_free_click)
        // 第二次领取
        const { data } = await getTaskClaimReward({
          taskCode,
        })
        if (data?.code === 0 && data?.result?.[taskCode]) {
          // 更新会员信息
          globalStore.updateUserInfo(data.result?.[taskCode])
          onSucess()
        }
      }
    } catch (err) {
      console.error(err)
    }
  }, [disabled])

  // 获取会员天数
  const fetchMemberTriaPackageInfo = async () => {
    const channel: string = router?.query?.channel || ''
    try {
      let origin: any =
        Cookies.get(COOKIES_MAP.GIVEAWAY_CHANNEL, { domain: '.creativebooster.com' }) || ''
      if (origin?.toLocaleUpperCase() === 'SSO') {
        origin = ''
      }
      const queryOrigin =
        channel &&
        [
          'SINO_CLICK',
          'META',
          'CMP',
          'ADVERTISERS',
          'FBE',
          'CM',
          'DEMAND',
          'INQUIRYOPPORTUNITY',
          'EDM',
          'BEYOND_CLICK_PUBLIC',
          'SINO_PUBLIC',
          'GOOGLE',
          'MINI_PROGRAM',
          'MEET_GAME',
        ].includes(channel)
          ? channel
          : 'DEMAND'
      const originParasm = origin ? { origin } : { origin: queryOrigin }
      const params: any = isFbe ? { language: 'ENGLISH', origin: 'FBE' } : originParasm
      const { data } = await getMemberTriaPackageInfo(params)
      if (data?.code === 0) {
        setMemberTriaInfo(data?.result || {})
      }
    } catch (error) {
      console.error(`获取会员套餐详情失败：${error}`)
    }
  }

  useEffect(() => {
    fetchMemberTriaPackageInfo()
  }, [])

  const renderInfo = () => {
    const paymentCycleCount = memberTriaInfo.paymentCycleCount
    const paymentCycle = `${memberTriaInfo.paymentCycle}`
    if (paymentCycle === '0') {
      // 月
      return dynamicTrans(t('components:t88'), { paymentCycleCount })
    }
    if (paymentCycle === '1') {
      // 季度
      return dynamicTrans(t('components:t89'), { paymentCycleCount })
    }
    if (paymentCycle === '2') {
      // 年
      return dynamicTrans(t('components:t91'), { paymentCycleCount })
    }
    if (paymentCycle === '3') {
      // 天
      return dynamicTrans(t('components:t92'), { paymentCycleCount })
    }
  }
  const txt: string = renderInfo()
  return (
    <div
      className={classNames(styles['member-area-wrapper'], {
        [props.classNames]: props.classNames,
        [styles.disabled]: props.disabled,
      })}
    >
      <div className="member-area-content" onClick={onClick ? onClick : onDefaultClick}>
        <IconSvg type="icon-huangguanshen" style={{ with: 16 }} />
        <span className="info" title={txt}>
          {txt}
        </span>
        <i
          style={{
            background: '#532E14',
            display: 'flex',
            width: 18,
            height: 18,
            borderRadius: 9,
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconSvg type="icona-you1" style={{ color: '#fff', fontSize: 8 }} />
        </i>
      </div>
    </div>
  )
})

export default ProbationaryMemberArea
export { useSucessResultModal, EVENT_NAME }
